import { EditIcon } from "../../../atoms/icons/edit";
import React from "react";

export const MobileMainText = () => {
  return (
    <>
      <div className="irq-top-text border-bottom">
        Here are today's loan options based on your information
      </div>
      <div className="irq-top-text-subtitle">
        <p>Choose up to five loans you'd like to compare below.</p>
        <p>
          Need more information? Click "View Details" for an in-depth breakdown
          of the cost of the loan.
        </p>
        <p>
          Click the
          <EditIcon
            className="edit-icon-mobile"
            fill="white"
            width="16"
            height="16"
          />
          edit icons if you need to adjust your information.
        </p>
      </div>
    </>
  );
};
